import React, { useState } from 'react';
// Make sure to create and import the corresponding CSS file
import './Faq.css';
import DefaultData from '../../CompanyData/DefaultData';

const Faq = () => {
    // State to keep track of the currently open FAQ item index
    const [openIndex, setOpenIndex] = useState(null);

    // Handler to toggle the accordion item
    const handleToggle = (index) => {
        // If the clicked item is already open, close it. Otherwise, open it.
        setOpenIndex(openIndex === index ? null : index);
    };

    // Storing FAQs in an array of objects for easy management.
    // Note: The 'answer' for the contact question now includes HTML for the links.
    const faqData = [
        {
            question: 'How do I search for flights or holidays on your website?',
            answer: '<p>Navigate to our homepage and enter your departure city, destination, travel dates, and other preferences in the search bar. Click "Search" to view available options.</p>'
        },
        {
            question: 'What types of flights do you offer?',
            answer: '<p>We offer a wide range of flights, including economy, business, and first class. You can also choose from various airlines to find the best fit for your travel needs.</p>'
        },
        {
            question: 'Can I book a complete holiday package on your website?',
            answer: '<p>Absolutely! In addition to flights, we provide comprehensive holiday packages that may include accommodations, transportation, and activities. Simply select the "Holidays" tab on our website to explore these options.</p>'
        },
        {
            question: 'Are the prices displayed inclusive of all fees and taxes?',
            answer: '<p>Yes, the prices you see on our website include all applicable fees and taxes. There are no hidden charges, and the displayed amount is the total cost you will pay.</p>'
        },
        {
            question: 'How can I make a payment for my booking?',
            answer: '<p>We accept various payment methods, including credit/debit cards and other secure online payment options. Follow the prompts during the checkout process to complete your payment.</p>'
        },
        {
            question: 'What is your cancellation policy?',
            answer: '<p>Cancellation policies vary depending on the airline or holiday package. You can find detailed information during the booking process, and we recommend reviewing the terms and conditions before finalizing your reservation.</p>'
        },
        {
            question: 'How will I get my money back after a cancellation?',
            answer: '<p>We will credit the money back to the same account you used while making the booking. For example, if you used your credit card, we will make an appropriate charge reversal. If you used your debit card, we will credit the money back to the debit card.</p>'
        },
        {
            question: 'How long does it take to process a refund?',
            answer: '<p>We usually process the refund within 4 working days of cancellation. However, it may take slightly longer to reflect in your account statement depending upon your bank. We’ve noticed that it takes about 14 working days for most refunds to hit their respective accounts.</p>'
        },
        {
            question: 'I still haven’t received my refund. Help!',
            answer: '<p>Please email us at' + DefaultData?.DEFAULTCOMPANYEMAIL + 'or contact us at' + DefaultData?.DEFAULTCOMPANYPHONENUMBER + 'with your booking details.</p>'
        },
        {
            question: 'What if I encounter issues during my trip?',
            answer: '<p>Our customer support team is available 24/7 to assist you. Contact us through the provided helpline or email, and we will promptly address any concerns or issues you may have during your journey.</p>'
        }
    ];

    const heroStyle = {
        backgroundImage: `url('/assets/images/Faq.png')`, // A relevant, inviting image
    };

    return (
        <div className="main-content">
            {/* Hero Section */}
            <div className="faq-hero-section" style={heroStyle}>
                <div className="hero-overlay">
                    <div className="container text-center">
                        <h1 className="hero-heading">Frequently Asked Questions</h1>
                        <p className="hero-subheading">Have questions? We're here to help.</p>
                    </div>
                </div>
            </div>

            {/* FAQ Accordion Section */}
            <div className="page-content">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="faq-accordion">
                                {faqData.map((item, index) => (
                                    <div className={`faq-item ${openIndex === index ? 'is-open' : ''}`} key={index}>
                                        <button className="faq-question" onClick={() => handleToggle(index)}>
                                            <span>{item.question}</span>
                                            <i className="ri-arrow-down-s-line faq-icon"></i>
                                        </button>
                                        <div className="faq-answer-content">
                                            {/* Using dangerouslySetInnerHTML to render the HTML content in answers */}
                                            <div className="faq-answer" dangerouslySetInnerHTML={{ __html: item.answer }} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Faq;